import React, { useState } from 'react'
import {
    Form,
    Label,
    Header,
    Divider,
    Icon,
    Button,
    Segment,
} from 'semantic-ui-react'
import { Modal } from 'react-bootstrap'
import { toCredit } from '../../../utils/helpers'

const MARGIN_PERCENTAGE = 54

const Credit = ({ job, payment, updatePayment, updatePage }) => {
    const { amount, description } = payment
    const { team, type: projectType } = job.project
    const { name: teamName, perCreditPrice } = team

    const isDecibio = teamName === 'Decibio'
    const marginAmount = parseFloat(
        (amount / (1 - MARGIN_PERCENTAGE / 100) - amount).toFixed(2)
    )
    const marginBasedCredits =
        Math.round(
            (amount / (1 - MARGIN_PERCENTAGE / 100) / perCreditPrice) * 100
        ) / 100
    const [credits, setCredits] = useState(
        isDecibio ? marginBasedCredits : payment.credits
    )

    const onNext = () => {
        updatePayment({ credits })
        updatePage('CONFIRM')
    }
    const onBack = () =>
        payment.method === 'Check' ? updatePage('CHECK') : updatePage('PAYMENT')

    return (
        <Modal.Body>
            <Header as="h6" className="top-margin-small">
                Team: {teamName} <br /> <br />
                Credit deduct method:
                <Header.Subheader>
                    {isDecibio
                        ? 'Partial credit based on a margin'
                        : 'Credit threshold based on expert rate'}
                </Header.Subheader>
            </Header>
            <div>
                {isDecibio && (
                    <div>
                        <Segment>
                            <Header as="h4">
                                {`Total honorarium: $${amount} USD`}
                                <Header.Subheader>
                                    <div className="recommendation">
                                        {description}
                                    </div>
                                </Header.Subheader>
                            </Header>
                            <Header as="h4">
                                {`Margin: ${MARGIN_PERCENTAGE}%`}
                                <Header.Subheader>
                                    <span className="recommendation">
                                        +${marginAmount} margin
                                    </span>
                                </Header.Subheader>
                            </Header>
                            <Header as="h4">
                                {`Per credit price: $${perCreditPrice} per credit`}
                            </Header>
                        </Segment>
                        <Divider />
                    </div>
                )}
                <Form.Group>
                    <Header as="h6">Total credit(s) to deduct</Header>
                    <Form.Input
                        labelPosition="right"
                        type="number"
                        min="0"
                        placeholder="Amount"
                        value={credits}
                        step="0.1"
                        onChange={(e, { value }) => {
                            setCredits(parseFloat(value))
                        }}
                    >
                        <input />
                        <Label>Credit(s)</Label>
                    </Form.Input>
                    {isDecibio && (
                        <span className="recommendation">
                            {`$${(credits * perCreditPrice).toFixed(2)}
                            converted to credits`}
                        </span>
                    )}
                </Form.Group>
            </div>
            {!isDecibio && (
                <div className="recommendation bottom-margin">
                    {projectType === 'Interview' &&
                        `Expert hourly rate: ${toCredit(
                            job.user.expert.hourlyRate
                        )} credit(s) `}{' '}
                    <br />
                </div>
            )}
            {projectType === 'Interview' && !isDecibio && (
                <div>
                    Credit Threshold for non-DBC Clients:
                    <br />
                    - Interviews ≤10 min = 0 credits;
                    <br />
                    - ≤450 = 1 credit;
                    <br />
                    - $451-$750 = 1.5 credits;
                    <br />- $751+ = 2 credits;
                </div>
            )}
            {projectType === 'Survey' && !isDecibio && (
                <div>
                    <br />
                    Standard rate for surveys is 0.25 credit per response
                </div>
            )}
            <Modal.Footer>
                <Button icon basic onClick={onBack}>
                    <Icon name="angle left" />
                </Button>
                <Button onClick={onNext}>Next</Button>
            </Modal.Footer>
        </Modal.Body>
    )
}

export default Credit
